<template>
  <div class="refund">
    <h3>结算管理</h3>
    <el-form :inline="true" ref="filter" class="demo-form-inline" size="mini">
      <el-form-item label="结算单号">
        <el-input v-model="filter.billId" placeholder="结算单号"></el-input>
      </el-form-item>
      <el-form-item label="甲方ID">
        <el-input v-model="filter.userAId" placeholder="甲方ID"></el-input>
      </el-form-item>
      <el-form-item label="乙方ID">
        <el-input v-model="filter.userBId" placeholder="乙方ID"></el-input>
      </el-form-item>
      <el-form-item label="乙方昵称">
        <el-input v-model="filter.partyBName" placeholder="乙方昵称"></el-input>
      </el-form-item>
      <el-form-item label="合同编号">
        <el-input v-model="filter.contractId" placeholder="订单编号"></el-input>
      </el-form-item>
      <el-form-item label="报价单号">
        <el-input v-model="filter.quotationId" placeholder="报价单号"></el-input>
      </el-form-item>

      <el-form-item label="结算时间">
        <el-date-picker v-model="filter.startTime" type="datetime" placeholder="开始时间" format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="到">
        <el-date-picker v-model="filter.endTime" type="datetime" placeholder="结束时间" format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="结算单状态">
        <el-select v-model="filter.billStatus">
          <el-option label="全部职位" value=""></el-option>
          <el-option v-for="(val, key) in map.finance.settlementStatus" :key="key" :label="val"
            :value="key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker v-model="filter.createStartTime" type="datetime" placeholder="开始时间" format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="到">
        <el-date-picker v-model="filter.createEndTime" type="datetime" placeholder="结束时间" format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="fetch(1)" size="mini">查询</el-button>
          <el-button style="margin-left: 10px" type="primary" :disabled="loading_disabled" size="mini"
            @click="exportExcel()">导出</el-button>
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-table :data="list" size="mini">
      <el-table-column prop="id" label="结算单号"></el-table-column>
      <el-table-column prop="contractId" label="合同编号"></el-table-column>
      <el-table-column prop="contractTitle" label="合同名称"></el-table-column>
      <el-table-column prop="userAName" label="甲方名称"></el-table-column>
      <el-table-column prop="userBName" label="乙方名称"></el-table-column>
      <el-table-column prop="amount" label="结算总额"></el-table-column>
      <el-table-column prop="couponAmount" label="优惠券金额"></el-table-column>
      <el-table-column prop="actuallyVat" label="增值税金额"></el-table-column>
      <el-table-column prop="actuallyPaid" label="实付金额"></el-table-column>
      <el-table-column prop="amountReceive" label="乙方收入"></el-table-column>
      <el-table-column prop="status" label="结算单状态">
        <template slot-scope="scope">{{
          map.finance.settlementStatus[scope.row.status]
        }}</template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间"></el-table-column>
      <el-table-column prop="launchTime" label="结算时间"></el-table-column>
      <el-table-column prop="dcnStatus" label="是否DCN">
        <template slot-scope="scope">{{
          scope.row.dcnStatus == 1 ? '是' : '否'
        }}</template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button type="text" @click="getToken(scope.row)">查看结算详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <br />
    <div style="float: right">
      <el-pagination background layout="prev, pager, next" :page-size="20" @current-change="(i) => (pageNum = i)"
        :page-count="pageNum" :total="total" ref="pagination">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import api from "../api";
import map from "../../datamap";
const { settlement, order } = api;

import moment from "moment";

export default {
  name: "settlement",
  data() {
    return {
      map,
      loading: true,
      loading_disabled: false,
      list: [],
      total: 0,
      limit: 20,
      pageNum: 1,
      limit: 20,
      filter: {
        limit: 20,
        pageNum: 1,
        partyBName: "",
        billStatus: "",
        contractId: "",
        quotationId: "",
        billId: "",
        startTime: "",
        endTime: "",
        userAId: "",
        userBId: "",
        createStartTime: "",
        createEndTime: "",
      },
    };
  },
  watch: {
    pageNum() {
      this.fetch();
    },
  },
  created() {
    if (this.$route.query.role == 1) {
      this.filter.userAId = this.$route.query.userId;
      this.filter.billStatus = this.$route.query.billStatus;
    }
    if (this.$route.query.role == 2) {
      this.filter.userBId = this.$route.query.userId;
      this.filter.billStatus = this.$route.query.billStatus;
    }
  },
  methods: {
    async fetch(num) {
      this.loading = true;
      if (num == 1) this.pageNum = 1;
      let {
        partyBName,
        billStatus,
        contractId,
        quotationId,
        billId,
        startTime,
        endTime,
        userAId,
        userBId,
        createStartTime,
        createEndTime,
      } = this.filter;

      let obj = {
        pageNum: this.pageNum,
        limit: this.limit,
        partyBName,
        billStatus,
        contractId,
        quotationId,
        billId,
        startTime,
        endTime,
        userAId,
        userBId,
        createStartTime,
        createEndTime,
      };
      // const obj = this.filter;
      let res = await settlement.list(obj);
      this.list = res.data.data;
      this.loading = false;
      this.total = res.data.pageinfo.totalCount;
    },
    async update(item) {
      let res = await settlement.update({
        id: item.id,
      });

      let { code } = res.data;
      if (code === 200) {
        this.$message.success("更新数据成功 ");
      }
      this.fetch();
    },
    async search() {
      this.$refs.pagination.internalCurrentPage = 1;
      this.pageNum = 1;
      this.fetch();
    },
    async getToken(row) {
      let obj = {
        userId: row.userBId,
      };
      let {
        data: { code, data },
      } = await order.token(obj);
      if (code == 200) {
        let url = `${this.frontUrl}/bill/detail/${row.aesBillId}?encrypt_code=${data}`;
        window.open(url, "_blank");
      }
    },

    async exportExcel() {
      this.loading = true;
      let obj = this.filter;
      let resp = await settlement.export(obj);
      let objectUrl = URL.createObjectURL(new Blob([resp.data]));
      let link = document.createElement("a");
      link.download = decodeURIComponent("结算管理明细列表.xlsx");
      link.href = objectUrl;
      link.click();
      this.loading = false;
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>
<style>
.user-list {}
</style>


// WEBPACK FOOTER //
// src/views/finance/settlement.vue